import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";
import { Button, FormGroup, Label, Input, Card, CardBody, CardHeader, Row, Col, Table } from "reactstrap";
import { getZoneListByPlace, getSubZoneListByZone, getTicketType, getTicketSubType, getTicketSubSubType, getAllZonesByPlace } from "../../redux/actions/indexActions";
import { MdAdd, MdRemove } from 'react-icons/md';
import AdditionalFormFields from "./AdditionalFormFields";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import { Link } from "react-router-dom";

const PlaceZone = ({ placeId }) => {
    const dispatch = useDispatch();
    const { auth } = useSelector((state) => state.AuthReducer);
    const { indexReducer: { PlaceZonelists, SubZonelists ,TicketTypeList, TicketSubTypeList ,TicketSubSubTypeList,zoneList,subZoneList,subSubZoneList} } = useSelector((state) => state);
    const [placeZoneId, setPlaceZoneId] = useState(0);
    const [isEdit, setIsEdit] = useState({
        zone:false,
        subZone:false,
        subSubZone:false,
    });
    const [placeZone, setPlaceZone] = useState("");
    const [SubZoneId, setSubZoneId] = useState(0);
    const [SubZone, setSubZone] = useState([{id:'',sub_zone: '' }]);
    const [SubSubZone, setSubSubZone] = useState([{ id:'',sub_sub_zone: "" }]);
    const [ticketTypes, setTicketTypes] = useState({
        ticket_type_id:'',
        ticket_sub_type_id:'',
        ticket_sub_sub_type_id:'',
    });
    
    const handleTicketTypes = (e) => {
        const { name,value } = e.target;
        setTicketTypes((prev) => ({
            ...prev,
            [name] : value,
        }));
        if(name == 'ticket_type_id'){
            dispatch(getTicketSubType(auth.token, value));
        }
        if(name == 'ticket_sub_type_id'){
            dispatch(getTicketSubSubType(auth.token, value));
        }
    };
    const HandleZone = (e) => {
        const { value } = e.target;
        dispatch(getSubZoneListByZone(auth.token, value));
        setPlaceZoneId(value);
        console.log("SubZonelists", SubZonelists);
    };
    const [errors, setErrors] = useState({});
    useEffect(() => {
        dispatch(getZoneListByPlace(auth.token, placeId));
        dispatch(getTicketType(auth.token, placeId));
        dispatch(getAllZonesByPlace(auth.token, placeId));
    }, [dispatch, auth.token, placeId]);
    const addService = () => {
        setSubZone([...SubZone, { sub_zone: '' }]);
    };
    const handlePlaceZoneVehicalsSubmit = () => {
        if (!placeZoneId) {
            toast.error("Zone ID is required.");
            return;
        }
        if (!Array.isArray(SubZone) || SubZone.length === 0 || SubZone.some(sz => !sz.sub_zone.trim())) {
            toast.error("valid sub-zone  required.");
            return;
        }
        const placeZoneForm = new FormData();
        placeZoneForm.append("zone_id", placeZoneId);
        placeZoneForm.append("sub_zone", JSON.stringify(SubZone));
        axios.post(`/api/admin/v1/addUpdate-sub-zone`, placeZoneForm, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${auth?.token}`,
            },
        }).then((res) => {
            toast.success(res.data?.message || "Sub-zone added successfully.");
            dispatch(getAllZonesByPlace(auth.token, placeId));
            dispatch({
                type: "ADD_SUB_ZONE_LIST_BY_ZONE_FULFILLED",
                payload: res.data?.data,
            });
            setSubZone([{id:'',sub_zone: '' }]);
            setPlaceZone("");
            setPlaceZoneId("");
            setTicketTypes({
                ticket_type_id:'',
                ticket_sub_type_id:'',
                ticket_sub_sub_type_id:'',
            });
            setIsEdit(prev => ({
                ...prev,
                subZone:false,
            }));
        }).catch((err) => {
            console.error("Error submitting form:", err);

            const errorMessage = err.response?.data?.message || "An error occurred";
            toast.error(errorMessage);

            if (err.response?.data?.errors) {
                setErrors(err.response.data.errors);
            } else {
                setErrors({ general: errorMessage });
            }
        });
    };
    const removeService = (index) => {
        const updatedSubZone = SubZone.filter((_, i) => i !== index);
        setSubZone(updatedSubZone);
    };
    const inputServiceHandler = (e, index) => {
        const { name, value } = e.target;
        const updatedSubZone = [...SubZone];
        updatedSubZone[index][name] = value;
        setSubZone(updatedSubZone);
    };
    const addSubSubZoneBox = () => {
        const updatedSubType = [...SubSubZone];
        updatedSubType.push({ sub_sub_zone: "" });
        setSubSubZone(updatedSubType);
    };
    const SubZoneHandler = (e) => {
        const { value } = e.target;
        setSubZoneId(value);
    };
    const handlePlaceZoneSubmit = () => {
        if (!placeZone || !placeId) {
            toast.error("Both Place Zone and Place are required");
            return;
        }
        const placeZoneForm = new FormData();
        placeZoneForm.append("place_zone", placeZone);
        placeZoneForm.append("place_id", placeId);
        placeZoneForm.append("id",placeZoneId);
        placeZoneForm.append("status", 1);
        placeZoneForm.append("ticket_type_id",ticketTypes.ticket_type_id);
        placeZoneForm.append("ticket_sub_type_id",ticketTypes.ticket_sub_type_id);
        placeZoneForm.append("ticket_sub_sub_type_id",ticketTypes.ticket_sub_sub_type_id);

        console.log("Submitting Place Zone Form:", Object.fromEntries(placeZoneForm));

        axios.post(`/api/admin/v1/add-place-zone`, placeZoneForm, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${auth?.token}`,
            },
        })
            .then((res) => {
                toast.success(res.data?.message || "Place zone added successfully!");
                dispatch(getAllZonesByPlace(auth.token, placeId));
                setIsEdit(prev => ({zone:false}));
                setPlaceZone("");
                setErrors({});
            })
            .catch((err) => {
                const errorMessage = err.response?.data?.message || "An error occurred";
                toast.error(errorMessage);
                setErrors(err.response?.data || {});
            });
    };

    const inputSubSubZoneHandler = (e, subSubIndex) => {
        const { name, value } = e.target;
        const updatedSubType = [...SubSubZone];
        updatedSubType[subSubIndex][name] = value;
        setSubSubZone(updatedSubType);
    };
    const removeSubSubZone = (subSubIndex) => {
        setSubSubZone(SubSubZone.filter((_, i) => i !== subSubIndex));
    };
    const handleSubmitSubSubZone = () => {
        const errors = {};
        if (!SubZoneId) errors.SubZoneId = "Sub Zone is required";

        if (!SubSubZone || !Array.isArray(SubSubZone) || SubSubZone.length === 0) {
            errors.SubSubZone = "At least one Sub-Sub Zone is required";
        } else {
            SubSubZone.forEach((sub, index) => {
                if (!sub.sub_sub_zone.trim()) {
                    errors[`SubSubZone_${index}`] = `Sub-Sub Zone at index ${index + 1} is required`;
                }
            });
        }
        if (Object.keys(errors).length > 0) {
            setErrors(errors);
            Object.values(errors).forEach((error) => toast.error(error));
            return;
        }
        const form = new FormData();
        form.append("zone_id", placeZoneId);
        form.append("sub_zone_id", SubZoneId);
        form.append("sub_sub_zone", JSON.stringify(SubSubZone));

        axios.post(`/api/admin/v1/addUpdate-sub-sub-zone`, form, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${auth?.token}`,
            },
        }).then((res) => {
            toast.success(res.data?.message);
            setSubSubZone([{ id:'',sub_sub_zone: ""}]);
            setErrors({});
            dispatch(getAllZonesByPlace(auth.token, placeId));
            setSubZoneId('');
            setTicketTypes({
                ticket_type_id:'',
                ticket_sub_type_id:'',
                ticket_sub_sub_type_id:'',
            });
            setIsEdit(prev => ({
                ...prev,
                subSubZone:false,
            }));
            setIsEdit(prev => ({
                ...prev,
                subSubZone:false,
            }));
        }).catch((err) => {
            toast.error(err.response.data?.message || "An error occurred");
            setErrors(err.response.data);
        });
    };

    const handleZoneDel = (id) => {
    if (window.confirm("Are You Sure You Want To Delete This Zone")) {
        axios
            .delete(`/api/admin/v1/zone-delete/${id}`, {
            headers: {
                Authorization: `Bearer ${auth?.token}`,
            },
            })
            .then((res) => {
                toast.success(res.data.message);
                dispatch(getAllZonesByPlace(auth.token, placeId));
            })
            .catch((err) => toast.error("Somthing Went Wrong"));
        }
    };
    const handleSubZoneDel = (id) => {
    if (window.confirm("Are You Sure You Want To Delete This Sub Zone")) {
        axios
            .delete(`/api/admin/v1/sub-zone-delete/${id}`, {
            headers: {
                Authorization: `Bearer ${auth?.token}`,
            },
            })
            .then((res) => {
                toast.success(res.data.message);
                dispatch(getAllZonesByPlace(auth.token, placeId));
            })
            .catch((err) => toast.error("Somthing Went Wrong"));
        }
    };
    const handleSubSubZoneDel = (id) => {
    if (window.confirm("Are You Sure You Want To Delete This Sub Sub Zone")) {
        axios
            .delete(`/api/admin/v1/sub-sub-zone-delete/${id}`, {
            headers: {
                Authorization: `Bearer ${auth?.token}`,
            },
            })
            .then((res) => {
                toast.success(res.data.message);
                dispatch(getAllZonesByPlace(auth.token, placeId));
            })
            .catch((err) => toast.error("Somthing Went Wrong"));
        }
    };

    useEffect(() => {
        console.log('subSubZoneList>>',subSubZoneList);
    },[subSubZoneList])
    return (
        <div className="container">
            <Row>
                <Col md={4} className="mt-3">
                    <div className="mb-3">
                        <Input type="select" name="ticket_type_id"
                            value={ticketTypes.ticket_type_id}
                            onChange={handleTicketTypes}
                        >
                            <option value="">Select Ticket Type</option>
                                {TicketTypeList.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.ticket_type}
                                    </option>
                                ))}
                        </Input>
                        <span className="d-block text-danger">{errors?.ticket_type_id}</span>
                    </div>
                </Col>
                <Col md={4} className="mt-3">
                    <div className="mb-3">
                        <Input type="select" name="ticket_sub_type_id"
                            value={ticketTypes.ticket_sub_type_id}
                            onChange={handleTicketTypes}
                        >
                            <option value="">Select Ticket Sub Type</option>
                                {TicketSubTypeList.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.sub_type}
                                    </option>
                                ))}
                        </Input>
                        <span className="d-block text-danger">{errors?.ticket_sub_type_id}</span>
                    </div> 
                </Col>
                <Col md={4} className="mt-3">
                    <div className="mb-3">
                        <Input type="select" name="ticket_sub_sub_type_id"
                            value={ticketTypes.ticket_sub_sub_type_id}
                            onChange={handleTicketTypes}
                        >
                            <option value="">Select Ticket Type</option>
                                {TicketSubSubTypeList.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.sub_sub_type}
                                    </option>
                                ))}
                        </Input>
                        <span className="d-block text-danger">{errors?.ticket_sub_sub_type_id}</span>
                    </div> 
                </Col>
            </Row>
            <Card className="mb-4 shadow-sm">
                <CardHeader className="bg-primary text-white">Add Place Zone</CardHeader>
                <CardBody>
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <FormGroup>
                                <Label className="fw-bold">Zone <span className="text-danger">*</span></Label>
                                <Input type="text" name="place_zone" value={placeZone} onChange={(e) => setPlaceZone(e.target.value)} placeholder="Enter Zone Name" />
                                {errors?.zone_name && (
                                    <span className="d-block text-danger mt-1">{errors.zone_name}</span>
                                )}
                            </FormGroup>
                        </div>
                        <div className="col-md-3 mt-2 text-end">
                            {isEdit.zone ? (
                                <Button className="bg-success text-white px-3" size="sm" onClick={handlePlaceZoneSubmit}>Update Place Zone</Button>
                            ):(
                                <Button className="bg-success text-white px-3" size="sm" onClick={handlePlaceZoneSubmit}>+ Add Place Zone</Button>
                            )}
                        </div>
                    </div>
                </CardBody>
            </Card>
            <div className="row">
                <div className="col-md-6">
                    <Card className="mb-4 shadow-sm">
                        <CardHeader className="bg-secondary text-white d-flex justify-content-between align-items-center">
                            <h6 className="mb-0">Sub Zone </h6>
                            {isEdit.subZone != true && (
                                <Button className="bg-success text-white" size="sm" onClick={addService}>
                                    <MdAdd size={22} /> Add Sub Zone
                                </Button>
                            )}
                        </CardHeader>
                        <CardBody>
                            <FormGroup>
                                <Label className="fw-bold">Place Zone <span className="text-danger">*</span></Label>
                                <Input type="select" name="zone_id" value={placeZoneId} onChange={HandleZone}>
                                    <option value="">Select Zone</option>
                                    {zoneList.map((item) => (
                                        <option key={item.id} value={item.id}>{item.zone_name}</option>
                                    ))}
                                </Input>
                                {errors?.place_id && (<span className="d-block text-danger mt-1">{errors.place_id}</span>)}
                            </FormGroup>

                            {SubZone.map((service, index) => (
                                <div className="d-flex align-items-center rounded p-3 my-2 bg-light border" key={index}>
                                    <FormGroup className="flex-grow-1 me-2 mb-0">
                                        <Label className="fw-bold">Sub Zone</Label>
                                        <Input type="text" name="sub_zone" value={service.sub_zone || ""} onChange={(e) => inputServiceHandler(e, index)} placeholder="Enter Sub Zone" />
                                    </FormGroup>
                                    <Button className="bg-danger text-white" size="sm" onClick={() => removeService(index)}>
                                        <MdRemove size={22} />
                                    </Button>
                                </div>
                            ))}
                            <div className="text-center mt-3">
                                {isEdit.subZone ? (
                                    <Button color="primary" onClick={handlePlaceZoneVehicalsSubmit}>Update Sub Zone</Button>
                                ):(
                                    <Button color="primary" onClick={handlePlaceZoneVehicalsSubmit}>Add Sub Zone</Button>
                                )}
                            </div>
                        </CardBody>
                    </Card>
                </div>
                <div className="col-md-6">
                    <Card className="shadow-sm">
                        <CardHeader className="bg-dark text-white d-flex justify-content-between align-items-center">
                            <h6 className="mb-0">Sub Sub Zone</h6>
                            {isEdit.subSubZone !=true && (
                                <Button className="bg-success text-white" size="sm" onClick={addSubSubZoneBox}>
                                    <MdAdd size={22} /> Add Sub Sub Zone
                                </Button>
                            )}
                        </CardHeader>
                        <CardBody>
                            <FormGroup>
                                <Label className="fw-bold">Select Sub Zone <span className="text-danger">*</span></Label>
                                <Input type="select" name="sub_zone" value={SubZoneId} onChange={SubZoneHandler}>
                                    <option value="">Select  Sub Zone</option>
                                    {SubZonelists.map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.sub_zone}
                                        </option>
                                    ))}
                                </Input>
                                <span className="text-danger">{errors?.tourist_type}</span>
                            </FormGroup>
                            {Array.isArray(SubSubZone) &&
                                SubSubZone.map((service, SubSubZoneIndex) => (
                                    <div className="d-flex align-items-center rounded p-3 my-2 bg-light border" key={SubSubZoneIndex}>
                                        <FormGroup className="flex-grow-1 me-2">
                                            <Label className="fw-bold">Sub Sub Zone</Label>
                                            <Input type="text" name="sub_sub_zone" value={service.sub_sub_zone || ""} onChange={(e) => inputSubSubZoneHandler(e, SubSubZoneIndex)} placeholder="Enter Sub Sub Zone" />
                                        </FormGroup>
                                        {isEdit.subSubZone != true && (
                                            <Button className="bg-danger text-white" size="sm" onClick={() => removeSubSubZone(SubSubZoneIndex)}>
                                                <MdRemove size={22} />
                                            </Button>
                                        )}
                                    </div>
                                ))}
                            <div className="text-center mt-3">
                                {isEdit.subSubZone ? (
                                    <Button color="primary" onClick={handleSubmitSubSubZone}>Update Sub Sub Zone</Button>
                                ):(
                                    <Button color="primary" onClick={handleSubmitSubSubZone}>Add Sub Sub Zone</Button>
                                )}
                            </div>
                        </CardBody>
                    </Card>
                </div>
                <AdditionalFormFields addFormType={'zone'} placeId={placeId}/>

            </div>
            <Row>
                <Col md={12} className="mt-3">
                    <Card className="mb-4 shadow-sm">
                        <CardHeader className="bg-secondary text-white">
                            <h6 className="mb-0">Ticket Type</h6>
                        </CardHeader>
                        <CardBody>
                            <Table bordered>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Zone</th>
                                        <th>Ticket Type</th>
                                        <th>Ticket Sub Type</th>
                                        <th>Ticket Sub Sub Type</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {zoneList.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item?.zone_name}</td>
                                        <td>{item?.ticket_type?.ticket_type ?? "N/A"}</td>
                                        <td>{item?.ticket_sub_type?.sub_type ?? "N/A"}</td>
                                        <td>{item?.ticket_sub_sub_type?.sub_sub_type ?? "N/A"}</td>
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <AiOutlineEdit
                                                    size={22}
                                                    className="text-warning me-3"
                                                    onClick={() => {
                                                        setPlaceZone(item?.zone_name);
                                                        setPlaceZoneId(item?.id);
                                                        setTicketTypes({
                                                            ticket_type_id:item?.ticket_type_id,
                                                            ticket_sub_type_id:item?.ticket_sub_type_id,
                                                            ticket_sub_sub_type_id:item?.ticket_sub_sub_type_id,
                                                        });
                                                        setIsEdit(prev => ({
                                                            ...prev,
                                                            zone:true,
                                                        }));
                                                    }}
                                                    />
                                                <AiOutlineDelete
                                                    size={22}
                                                    className="text-danger"
                                                    onClick={() => handleZoneDel(item.id)}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </Table>
                        </CardBody>
                    </Card>
                </Col>
                <Col md={6} className="mt-3">
                    <Card className="mb-4 shadow-sm">
                        <CardHeader className="bg-secondary text-white">
                            <h6 className="mb-0">Ticket Sub Type</h6>
                        </CardHeader>
                        <CardBody>
                            <Table bordered>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Zone</th>
                                        <th>Sub Zone</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {subZoneList.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item?.zone?.zone_name}</td>
                                        <td>{item?.sub_zone}</td>
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <AiOutlineEdit
                                                size={22}
                                                className="text-warning me-3"
                                                onClick={() => {
                                                    setPlaceZone(item?.zone_name);
                                                    setPlaceZoneId(item?.zone_id);
                                                    setTicketTypes({
                                                        ticket_type_id:item?.ticket_type_id,
                                                        ticket_sub_type_id:item?.ticket_sub_type_id,
                                                        ticket_sub_sub_type_id:item?.ticket_sub_sub_type_id,
                                                    });
                                                    setIsEdit(prev => ({
                                                        ...prev,
                                                        subZone:true,
                                                    }));
                                                    setSubZone([{ id:item?.id, sub_zone: item?.sub_zone }]);
                                                }}
                                                />
                                                <AiOutlineDelete
                                                    size={22}
                                                    className="text-danger"
                                                    onClick={() => handleSubZoneDel(item.id)}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </Table>
                        </CardBody>
                    </Card>
                </Col>
                <Col md={6} className="mt-3">
                    <Card className="mb-4 shadow-sm">
                        <CardHeader className="bg-secondary text-white">
                            <h6 className="mb-0">Ticket Sub Sub Type</h6>
                        </CardHeader>
                        <CardBody>
                            <Table bordered>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Sub Zone</th>
                                        <th>Sub Sub Zone</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {subSubZoneList.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item?.sub_zone?.sub_zone}</td>
                                        <td>{item?.sub_sub_zone}</td>
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <AiOutlineEdit
                                                size={22}
                                                className="text-warning me-3"
                                                onClick={() => {
                                                    // setPlaceZoneId(item?.sub_zone?.sub_zone?.zone_id);
                                                    setSubZoneId(item?.sub_zone_id);
                                                    dispatch(getSubZoneListByZone(auth.token, item?.sub_zone?.zone_id));
                                                    setIsEdit(prev => ({
                                                        ...prev,
                                                        subSubZone:true,
                                                    }));
                                                    setSubSubZone([{id:item?.id,sub_sub_zone:item?.sub_sub_zone }]);
                                                }}
                                                />
                                                <AiOutlineDelete
                                                    size={22}
                                                    className="text-danger"
                                                    onClick={() => handleSubSubZoneDel(item.id)}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </Table>
                        </CardBody>
                    </Card>
                </Col>
            </Row>


        </div>
    );
};
export default PlaceZone;
